<template>
      <v-app>
        <router-view/>
        <Status/>
      </v-app>
</template>

<script>
// @ is an alias to /src
import Status from '@/components/StatusBar.vue'

export default {
  name: 'AppView',
  components: {
    Status
  },
  data () {
    return {
      updateFound: false
    }
  },
  mounted () {
    try {
      const BC = new BroadcastChannel('BC')
      BC.addEventListener('message', (event) => {
        switch (event.data) {
          case 'cached':
          case 'updated':
            setTimeout(() => {
              this.updateFound = false
            }, 500)
            console.log('will now reload')
            location.reload()
            break
          case 'updatefound':
            this.updateFound = true
            console.log('update found !')
            break
          default:
            break
        }
      })
    } catch {
      // BroadcastChannel not supported by the broswer... (safari ?)
    }
  }
}
</script>

<style>
body {
  margin: 0px;
}

#app {
  font-family: aldrich;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
